import React, { useEffect, useRef } from 'react';

const KakaoAdBanner = ({ className, style }) => {
  const adRef = useRef(null);
  const scriptLoadedRef = useRef(false);
  const adInitialized = useRef(false);

  useEffect(() => {
    const loadKakaoAdScript = () => {
      // 스크립트가 이미 로드되었는지 확인
      if (document.querySelector('script[src*="ba.min.js"]') || scriptLoadedRef.current) {
        initializeAd();
        return;
      }

      // 카카오 애드핏 스크립트 동적 로드
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = '//t1.daumcdn.net/kas/static/ba.min.js';
      script.async = true;
      script.onload = () => {
        scriptLoadedRef.current = true;
        console.log('카카오 AdFit 스크립트 로드 완료');
        initializeAd();
      };
      script.onerror = () => {
        console.warn('카카오 애드핏 스크립트 로드 실패');
        showFallbackContent();
      };

      // head에 스크립트 추가
      document.head.appendChild(script);
    };

    const initializeAd = () => {
      if (adInitialized.current || !adRef.current) return;
      
      // 광고 요소 표시
      adRef.current.style.display = 'block';
      adInitialized.current = true;
      
      // AdFit API가 있는 경우 명시적으로 초기화 시도
      if (window.adfit && window.adfit.render) {
        try {
          window.adfit.render(adRef.current);
          console.log('카카오 광고 렌더링 완료');
        } catch (error) {
          console.warn('카카오 광고 렌더링 실패:', error);
          showFallbackContent();
        }
      }
    };

    const showFallbackContent = () => {
      if (adRef.current) {
        adRef.current.innerHTML = `
          <div style="
            background: linear-gradient(45deg, #f8f9fa, #e9ecef);
            border: 1px dashed #6c757d;
            border-radius: 8px;
            padding: 15px;
            text-align: center;
            color: #6c757d;
            font-size: 12px;
          ">
            <i class="fas fa-ad" style="margin-right: 5px;"></i>
            광고 영역 (개발 환경)
          </div>
        `;
        adRef.current.style.display = 'block';
      }
    };

    // 컴포넌트 마운트 시 스크립트 로드
    loadKakaoAdScript();

    // localhost 환경 감지 및 대체 콘텐츠 표시
    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1';
    
    if (isLocalhost) {
      const timer = setTimeout(() => {
        if (adRef.current && !adInitialized.current) {
          showFallbackContent();
        }
      }, 2000);
      
      return () => clearTimeout(timer);
    }

    return () => {};
  }, []);

  const defaultStyle = {
    width: '100%',
    textAlign: 'center',
    margin: '10px 0',
    ...style
  };

  return (
    <div className={`kakao-ad-container ${className || ''}`} style={defaultStyle}>
      <ins 
        ref={adRef}
        className="kakao_ad_area" 
        style={{display: 'none'}}
        data-ad-unit="DAN-A4GHaFlGIWY72V0u"
        data-ad-width="320"
        data-ad-height="50"
      />
    </div>
  );
};

export default KakaoAdBanner;
